import axios from 'axios';

let url = '';

switch (process.env.NODE_ENV) {
  case 'development':
    url = `https://api.artmutualrural.org.ar:8182/api/`//url = `http://www.intersistemas.net:8181/api/`
    break;

  case 'production':
    url = `https://api.artmutualrural.org.ar:8182/api/`
    break;

  default:
    break;
}

console.log('URL API: ' + url)
export default axios.create({
    baseURL: url  
});

// export default axios.create({
//   //baseURL:`https://www.artmutualrural.org.ar:8182/api/`
//   baseURL: `http://www.intersistemas.net:8181/api/`,
//   //baseURL:`https://www.artmutualrural.org.ar:8181/api/`//`https://localhost:44332/api`//`http://192.168.0.156:8181/api/`//`http://www.binarianet.com:8181/api/`//
// });

